<template>
<label class="checkbox-container" :class="{'disabled' : disabled}" :for="id">
  <input 
    type="checkbox" 
    :checked="modelValue"
    :id="id"
    @change="$emit('update:modelValue', $event.target.checked)"
    :disabled="disabled" 
    >{{checkBoxLabel}}
  <span class="checkmark"></span>
</label>
</template>
<script>
export default {
  name: 'CustomCheckBox',
  props:['checkBoxLabel', 'id', 'disabled', 'modelValue'],
  emits: ['update:modelValue']
};
</script>
<style lang="scss" scoped>
</style>